import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { LoggerService } from "src/app/services/infra/logger/logger.service";
import { AuthService } from "@auth0/auth0-angular";
import { Router } from "@angular/router";
import { Labels } from "src/app/labels/englishLabels";
import { DialogLayoutDisplay, ToastNotificationInitializer, ToastPositionEnum, ToastProgressBarEnum } from "@costlydeveloper/ngx-awesome-popup";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private _logger: LoggerService,
        private _auth: AuthService,
        private _router: Router,
    ) {}

    /**
     * Error interceptor
     * This will intercept each http response.
     * On each response it will check for errors and log the error.
     * It will handle specific status codes:
     *  401: Will logout the user and redirect the user to the login page.
     *  etc
     */
    public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.error instanceof ErrorEvent) {
                    this._logger.warn(`Got a client side error when calling this is client side error when calling
                     '${error.url} with headers ${JSON.stringify(error.headers)} - error message ${error.message}`);
                } else {
                    switch (error.status) {
                        case 401:
                            this._openNotification(Labels.errors[401], "", DialogLayoutDisplay.DANGER);
                            this._auth.logout();
                            this._router.navigateByUrl("/login");
                            break;
                    }
                }

                // Rule is disabled because no matter what we want to raise the error to he previous interceptor

                return throwError(() => error);
            }),
        );
    }

    private _openNotification(title: string, message: string, type: DialogLayoutDisplay) {
        const newToastNotification = new ToastNotificationInitializer();

        newToastNotification.setTitle(message);
        newToastNotification.setMessage(title);

        newToastNotification.setConfig({
            layoutType: type,
            progressBar: ToastProgressBarEnum.NONE,
            toastPosition: ToastPositionEnum.BOTTOM_FULL_WIDTH,
            autoCloseDelay: 5000,
        });

        newToastNotification.openToastNotification$();
    }
}
